export const FEATURE_FLAGS = {
  SPENDBACK: 'foreplay_sb'
}
